import React from 'react';
import { Icon } from './Icon';

import styles from './cardImage/cardImage.module.scss';

export class CardImage extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      isError: false,
    }
  }

  onLoad = () => this.setState({ isLoading: false })

  onError = () => this.setState({ isError: true })

  render() {
    const {
      className = '',
      src,
      noImageElement = <Icon name="NoData"/>,
      loadingMessage = 'Loading...',
    } = this.props;

    const { isLoading, isError } = this.state;

    return (
      <div className={`${styles.container} ${className}`}>
        {src ? <img
          src={src}
          alt=""
          onLoad={this.onLoad}
          onError={this.onError}
        /> : noImageElement}
        {src && !isError && !!loadingMessage && isLoading ? (
          <div className={styles.loading}>
            <span className={styles.loadingText}>
              {loadingMessage}
            </span>
          </div>
        ) : null}
      </div>
    );
  }
}
